var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-editor-wrapper"},[_c('div',{staticClass:"vm-editor-toolbar",attrs:{"id":"toolbar"}}),_c('div',{staticClass:"vm-editor-editor",style:({height:_vm.height}),attrs:{"id":"editor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }